import styled from 'styled-components'
import { Button_s, Colors } from 'styles/app-styles'

import { AutoComplete } from "primereact/autocomplete"
import { Calendar } from "primereact/calendar"
import DateText from "components/inputs/date-text"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Checkbox } from "primereact/checkbox"
import { ListBox } from "primereact/listbox"
import { MultiSelect } from 'primereact/multiselect';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { CheckboxInput } from "components/table/carousel/inputs"

export const InputBaseStyles = `
  border: 1px solid ${Colors.towerGrey};
  border-radius: 2px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  height: 30px;
  &:focus {
    outline: none;
  }
  &:focus, &.p-focus {
    background-color: ${Colors.inputFocus};
    border-color: ${Colors.blackPearl};
  }
  &.p-disabled, &:disabled {
    background-color: ${Colors.inputFocus} !important;
    color: ${Colors.blackPearl} !important;
    opacity: 0.5 !important;
  }
  &.has-errors {
    border-bottom-width: 1px !important;
    border-bottom-color: ${Colors.colorDanger} !important;
  }
`

export const Calendar_s = styled(Calendar)`
  input { ${InputBaseStyles} }
  .p-datepicker.p-input-overlay {
    background: ${Colors.white};
    border: 1px solid ${Colors.towerGrey};
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }
  .p-datepicker-calendar {
    color: ${Colors.blackPearl};
  }
  .p-datepicker-group {
    font-size: 14px;
  }
  .p-datepicker-header {
    background: ${Colors.inputFocus};
    color: ${Colors.darkDenim};
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .p-datepicker-title, .p-datepicker-header > .p-link {
    color: ${Colors.blackPearl};
    line-height: 14px !important;
    top: 0.4em;
  }
`

export const Checkbox_s = styled(Checkbox)`
  border: 1px solid ${Colors.towerGrey};
  border-radius: 2px;
  height: 30px;
  margin: 0 auto !important;
  width: 30px;
  .p-checkbox-box {
    background: ${({disabled}) => disabled ? Colors.towerGrey : Colors.white};
    height: 100% !important;
    opacity: ${({disabled}) => disabled ? '0.5' : '1'};
    width: 100% !important;
    &[aria-checked="false"]{
      > span.p-checkbox-icon { display: none; }
    }
    &.p-focus{
      outline: none;
    }
    span.p-checkbox-icon {
      font-size: 18px;
      line-height: 28px;
    }
  }
`

export const DateText_s = styled(DateText)`
  ${InputBaseStyles}
  padding: 0 8px;
  outline: none;
`

export const InputNumber_s = styled(InputNumber)`
  ${InputBaseStyles}
  &.p-inputwrapper-focus {
    border: none;
  }
  > input {
    border-color: ${Colors.towerGrey};
    border-style: none;
    padding: 0 8px;
  }
  input:focus {
    background-color: ${Colors.inputFocus};
    border: 1px solid ${Colors.blackPearl} !important;
    outline: none !important;
  }
`

export const InputText_s = styled(InputText)`
  ${InputBaseStyles}
  padding: 0 8px;
`

export const InputTextarea_s = styled(InputTextarea)`
  ${InputBaseStyles}
  height: auto;
  padding: 8px !important;
`

export const AutoComplete_s = styled(AutoComplete)`
  ${InputBaseStyles}
  padding: 0 8px;
`

export const Dropdown_s = styled(Dropdown)`
  ${InputBaseStyles}
  background-color: ${Colors.white};
  width: 158px;
  ${({wide}) => wide && 'width: 200px;'}
  .p-dropdown-panel {
    max-width: 100%;
  }
  .p-dropdown-trigger {
    background: ${Colors.athensGrey};
  }
  .p-inputtext {
    padding: 0 5px;
  }
  .p-inputtext, .p-dropdown-item {
    color: ${Colors.blackPearl};
  }
  .p-dropdown-filter {
    border: 1px solid ${Colors.towerGrey};
    font-size: inherit;
    line-height: 22px;
    height: 24px;
    margin: 4px;
    width: calc(100% - 8px);
    &:focus {
      outline: none;
    }
  }
  .p-dropdown-filter-icon {
    color: ${Colors.blackPearl};
    right: 8px;
  }
  .p-dropdown-item {
    height: 24px;
    line-height: 24px;
    margin: 0 !important;
    overflow: hidden;
    padding: 0 8px !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    &:hover {
      background: ${Colors.inputFocus};
      border-bottom: 1px solid ${Colors.towerGrey};
      border-top: 1px solid ${Colors.towerGrey};
      height: auto;
      overflow: auto;
      white-space: normal;
      word-break: break-word;
    }
    &.p-highlight {
      background: ${Colors.inputFocus};
      border: 1px solid ${Colors.blackPearl} !important;
    }
  }
  .p-dropdown-item.hovering {
    background: ${Colors.inputFocus};
    border-bottom: 1px solid ${Colors.towerGrey};
    border-top: 1px solid ${Colors.towerGrey};
    height: auto;
    overflow: auto;
    white-space: normal;
    word-break: break-word;
  }
  .p-dropdown-label {
    font-size: 14px;
    line-height: 28px;
  }
  div.p-dropdown-panel.p-connected-overlay-enter-done, div.p-dropdown-panel.p-input-overlay-visible {
    background: ${Colors.white};
    border: 1px solid ${Colors.towerGrey};
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

  }
  ul.p-dropdown-items.p-dropdown-list {
    padding: 0 !important;
  }
  .p-dropdown-trigger {
    width: 28px !important;
  }
  .p-dropdown-filter-icon {
    top: 18px !important;
  }
  &.drop-up {
    div.p-dropdown-panel {
      transform-origin: bottom;
      top: auto !important;
      bottom: 100%;
    }
  }
`

export const Select_s = styled.select`
  ${InputBaseStyles}
  background-color: ${Colors.white};
  width: 158px;
  ${({wide}) => wide && 'width: 200px;'}
`

export const ClearDropdown_s = styled(Button_s)`
  align-items: center;
  background: ${Colors.blackPearl} !important;
  border-radius: 100%;
  display: flex;
  height: 24px;
  margin-right: -24px;
  position: relative;
  right: 55px;
  top: 3px;
  width: 24px;
  z-index: 1;
  svg {
    height: 14px;
    width: auto;
    .r-svg {
      fill: ${Colors.white};
    }
  }
`

export const TableMultiselect_s = styled(MultiSelect)`
  background: ${Colors.white};
  height: 28px;
  padding: 0 8px;
  width: calc(100% - 2px);
  .p-checkbox {
    border: 1px solid ${Colors.towerGrey};
    height: 16px;
    width: 16px;
  }
  .p-checkbox-box {
    width: 16px;
  }
  .p-multiselect-label-container {
    line-height: 28px;
  }
  .p-multiselect-panel {
    background: ${Colors.white};
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    margin-top: 1px;
    padding: 4px 8px;
    top: 30px;
    .p-multiselect-header {
      border-bottom: 1px solid ${Colors.towerGrey};
      height: 30px;
      margin-bottom: 4px;
    }
    ul > li {
      height: 24px;
    }
    ul > li > span {
      padding-left: 5px;
    }
  }
`

export const CarouselDropdown_s = styled(Dropdown_s)`
  .p-dropdown-items-wrapper {
    max-height: 194px !important;
  }
  li.p-dropdown-item {
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

export const TableDropdown_s = styled(Dropdown_s)`
  background-color: inherit;
  border-radius: 0;
  height: 30px;
  margin: -1px 0 0 -1px;
  padding-left: 2px;
  vertical-align: middle;
  width: calc(100% - 1px);

  div.p-dropdown-panel {
    background: ${Colors.white};
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }
  .p-dropdown-items-wrapper {
    max-height: 119px !important;
  }
  div.p-dropdown-trigger {
    height: 26px;
    margin-top: 1px;
    > span.pi-chevron-down:before {
      color: ${Colors.blackPearl};
    }
  ul.p-dropdown-list {
    padding: 0.2em !important;
  }
  li.p-dropdown-item {
    font-size: 14px;
    height: auto;
    &:hover {
      background: ${Colors.inputFocus};
      border: 1px solid ${Colors.towerGrey} !important;
    }
  }
  span.p-dropdown-label.p-inputtext {
    color: ${Colors.blackPearl};
    font-weight: normal;
  }

`

// General listbox styling overrides
export const Listbox_s = styled(ListBox)`
  ${InputBaseStyles}
  border: 1px solid ${Colors.towerGrey};
  height: auto;
  padding: 5px !important;
  width: auto !important;
  div {
    align-items: center;
    display: flex;
  }
  input {
    margin-right: 6px;
  }
  ul.p-listbox-list {
    width: 100%;
  }
  li {
    margin-bottom: 0 !important;
    outline: none;
    padding: 2px 5px !important;
    &:hover { background-color: ${Colors.inputFocus}; }
  }
  span {
    font-size: 14px;
  }
  ${Checkbox}.listbox-checkbox {
    align-self: start;
    border: 1px solid ${Colors.towerGrey};
    line-height: 14px;
    margin: 2px 8px 2px 4px;
    height: 14px;
    width: 14px;
  }
  div.p-checkbox-box {
    height: 14px;
    width: 14px;
  }
`

// For our custom listbox with sorting, select all
export const ListboxHeaderSort_s = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SelectAllCheckbox_s = styled(CheckboxInput)`
  height: 14px;
  margin: 36px 0 0 8px !important;
  position: absolute;
  width: 14px !important;
  z-index: 1;
  span.p-checkbox-icon {
    font-size: 10px !important;
    line-height: 14px !important;
    margin-left: -1px;
  }
`

export const ListboxSection_s = styled.div`
  position: relative;
  ${SelectAllCheckbox_s} + div.p-listbox .p-listbox-filter-container {
    margin: 4px -2px 0 28px;
  }
  div.p-listbox-filter-container {
    > input {
      padding-left: 24px;
    }
    > span {
      left: 6px;
    }
  }
  li.p-listbox-item {
    > div > input {
      border: 1px solid ${Colors.towerGrey} !important;
      border-radius: 2px;
      height: auto;
      margin-bottom: 0;
    }
    span.p-checkbox-icon {
      font-size: 10px;
    }
  }
`